<template>
  <div class="row">
    <div class="col-12">
      <custom-result-not-found v-if="status.length === 0" />
      <time-line class="mt-4">
        <div v-for="(item, index) in status" :key="`item-index-${index}`">
          <time-line-item class="custom-time-line rounded">
            <template #icon>
              <em
                class="radius"
                :class="`fas fa-${getIconStatus(item.statusId)}`"
              />
            </template>
            <template #date>
              <div class="date-container">
                <div class="color-black font-16 font-weight-bold fulldate">
                  {{ item.requestStatusDate }}
                </div>
                <div class="color-black font-12 font-weight-normal hour">
                  {{ item.requestStatusHours }}
                </div>
              </div>
            </template>
            <div class="row mx-3">
              <div class="col-md-2 col-sm-12">
                <custom-balloon
                  :style="getColorStatus(item.statusColor)"
                  :text="item.statusName"
                />
              </div>
              <div class="col-md-10">
                <div class="row">
                  <div
                    v-if="item.statusId == requestStatus.Sometido"
                    class="col-12 ml-5 ml-md-5 ml-sm-0"
                  >
                    <div class="my-2">
                      <div class="color-gray-6 font-14 font-weight-normal">
                        Fecha de Solicitud:
                      </div>
                      <div
                        class="color-black font-16 font-weight-normal label-value"
                      >
                        {{ item.requestDate }}
                      </div>
                    </div>
                  </div>
                  <div class="col ml-5 ml-md-5 ml-sm-0">
                    <div class="color-gray-6 font-14 font-weight-normal">
                      {{
                        item.statusId == requestStatus.Sometido
                          ? 'Sometido por:'
                          : 'Determinado por:'
                      }}
                    </div>
                    <div
                      class="color-black font-16 font-weight-normal label-value"
                    >
                      {{ item.modifyUserName || item.createUserName }}
                    </div>
                  </div>
                </div>
                <div class="row bg-white rounded p-2 mt-3 ml-5 ml-md-5 ml-sm-0">
                  <div class="col">
                    <div class="color-gray-6 font-14 font-weight-normal">
                      {{
                        item.statusId == requestStatus.Sometido
                          ? 'Observación:'
                          : 'Comentario:'
                      }}
                    </div>
                    <div
                      class="color-black font-16 font-weight-normal label-value"
                    >
                      {{ item.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </time-line-item>
        </div>
      </time-line>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

export default {
  name: 'AEERequestHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    CustomBalloon,
  },
  computed: {
    getIconStatus() {
      return (statusId) => {
        switch (statusId) {
          case compensatoryRequestStatus.Nuevo:
            return 'file-invoice';
          case compensatoryRequestStatus.Aprobado:
            return 'check';
          case compensatoryRequestStatus.Denegado:
            return 'times-circle';
          case compensatoryRequestStatus.AprobadoModificado:
            return 'check';
          case compensatoryRequestStatus.Sometido:
            return 'flag';
          case compensatoryRequestStatus.ProcesoCompletado:
            return 'check';
          case compensatoryRequestStatus.SolicitudRechazada:
            return 'times-circle';
          case compensatoryRequestStatus.CompletadoPendientedeAprobacion:
            return 'flag';
          case compensatoryRequestStatus.DevueltoAProveedor:
            return 'flag';
          case compensatoryRequestStatus.ExcluidoPorEstrategia:
            return 'times-circle';
        }
      };
    },
    getColorStatus() {
      return (statusColor) => {
        return statusColor ? `background-color: ${statusColor}` : '';
      };
    },
    requestStatus() {
      return compensatoryRequestStatus;
    },
  },
  props: {
    status: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onDownloadFileHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
  },
};
</script>
